

const inpiration = function () {
 
  const finishSelector = Array.from(document.querySelectorAll('.js-finish input'));
  const colorSelector = Array.from(document.querySelectorAll('.js-color input'));
  const roomSelector = Array.from(document.querySelectorAll('.js-room input'));
  const galleryImages = Array.from(document.querySelectorAll('#inspiration-grid .image-wrapper'))
  const clear = document.querySelector('.clear-filters');


  const displayImgs = (img) => {
    if(img.classList.contains('gallery-hide')){    
      img.classList.remove('gallery-hide')      
    }
    img.classList.add('gallery-display')
  
  }
  const hideImgs = (img) => {
    if(img.classList.contains('gallery-display')){
    img.classList.remove('gallery-display')
    }
    img.classList.add('gallery-hide')     
    
  }
  let filters = {
    room: [],
    color: [],
    finish: []
   
  };
 
  const galleryFilter = (sel) => {
    let clickedFilter = ''
    if(sel !== 'clear'){
      clickedFilter = sel.dataset.filter;
    }else {
      clickedFilter == sel 
    }
    

    if(filters.finish.length == 0 && filters.color.length == 0 && filters.room.length == 0) {
      galleryImages.map(img => img.classList.remove('gallery-hide'))
      clear.style.display = 'none'
      return
    }

    clear.style.display = 'flex'

    galleryImages.map(img => {
      const dataRoom = img.dataset.room;
      const dataColor = img.dataset.color;
      const dataFinish = img.dataset.finish;
 
      const colorFilter = filters.color
      const finishFilter = filters.finish
      const roomFilter = filters.room

      const colorExists = filters['color'].length;
      const roomExists = filters['room'].length;
      const finishExists = filters['finish'].length;

      switch (clickedFilter) {
      case 'room':
        // if there is no selected room 
      if(!roomExists && (colorExists || finishExists)) {
          if(colorExists && finishExists) {
            if(finishFilter.includes(dataFinish) && colorFilter.includes(dataColor)) {
             displayImgs(img)
            }else {
             hideImgs(img)
            }   
        } else if(colorExists && !finishExists){
          if(colorFilter.includes(dataColor)) {
            displayImgs(img)
           }else {
            hideImgs(img)
           }   
        }else if(!colorExists && finishExists){
          if(finishFilter.includes(dataFinish)) {
            displayImgs(img)
           }else {
           hideImgs(img)
           }  
        }
      }else if(roomExists && (colorExists || finishExists)){ 
          if(colorExists && finishExists) {
            if(roomFilter.includes(dataRoom) && finishFilter.includes(dataFinish) && colorFilter.includes(dataColor)) {
             displayImgs(img)
            }else {
            hideImgs(img)
            }  
            
          }else if(!colorExists && finishExists) {
            if(roomFilter.includes(dataRoom) && finishFilter.includes(dataFinish)) {
             displayImgs(img)
            }else{
             hideImgs(img)
            }
          
          }else if(colorExists && !finishExists){
            if(roomFilter.includes(dataRoom) && colorFilter.includes(dataColor)) {
             displayImgs(img)
            }else{
             hideImgs(img)
            }
          }
        }else {
          if (roomFilter.includes(dataRoom)){
          displayImgs(img)
          }else{
           hideImgs(img)

          }
          
        }

        
      break;
      case 'color':
        // if there is no selected color
        if(!colorExists && (roomExists || finishExists)) {
          if(roomExists && finishExists) {
            if(finishFilter.includes(dataFinish) && roomFilter.includes(dataRoom)){
              displayImgs(img)
            }else{
              hideImgs(img)
            }
          }else if(roomExists && !finishExists) {
            if(roomFilter.includes(dataRoom)){
              displayImgs(img)
             
            }else{
              hideImgs(img)
            }
          }else if(!roomExists && finishExists){
            if(finishFilter.includes(dataFinish)){
              displayImgs(img)
            }else{
              hideImgs(img)
            }
          }
        }else if(colorExists && (roomExists || finishExists)) {
          if(roomExists && finishExists) {
            if(colorFilter.includes(dataColor) && roomFilter.includes(dataRoom) && finishFilter.includes(dataFinish)) {
              displayImgs(img)
            }else {
              hideImgs(img)
            }
          } else if(roomExists && !finishExists) {
            if(colorFilter.includes(dataColor) && roomFilter.includes(dataRoom)) {
              displayImgs(img)
            }else {
              hideImgs(img)
            }
          } else {
            if(colorFilter.includes(dataColor) && finishFilter.includes(dataFinish)){
              displayImgs(img)
            }else{
              hideImgs(img)
            }

          } 
        }else {
          if(colorFilter.includes(dataColor)) {
            displayImgs(img)
           }else {
            hideImgs(img)
           }   
        }

      break;

      case 'finish':
         // if there is no selected finish
        if(!finishExists && (roomExists || colorExists)) {
          if(roomExists && colorExists) {
            if(roomFilter.includes(dataRoom) && colorFilter.includes(dataColor)){
              displayImgs(img)
            
            }else{
              hideImgs(img)
            }
          } else if(roomExists && !colorExists){
            if(roomFilter.includes(dataRoom)){
              displayImgs(img)
              
            }else{
              hideImgs(img)
            }

          }else if(!roomExists && colorExists){
            if(colorFilter.includes(dataColor)){
              displayImgs(img)
            }else{
              hideImgs(img)
            }
          }
        } else if(finishExists && (roomExists || colorExists)){
          if(roomExists && colorExists) {
            if(roomFilter.includes(dataRoom) && finishFilter.includes(dataFinish) && colorFilter.includes(dataColor)) {
              displayImgs(img)
             }else {
             hideImgs(img)
             }  
          } else if(roomExists && !colorExists) {
            if(finishFilter.includes(dataFinish) && roomFilter.includes(dataRoom)){
              displayImgs(img)
            }else {
              hideImgs(img)
            }
          }else if(!roomExists && colorExists){
            if(finishFilter.includes(dataFinish) && colorFilter.includes(dataColor)){
              displayImgs(img)
            }else{
              hideImgs(img)
            }
          }
        }else{
          if(finishFilter.includes(dataFinish)) {
            displayImgs(img)
           }else {
            hideImgs(img)
           }   
        }
      break;
    
      case 'clear':
        displayImgs(img)
      break;

      }
    });
    const imagesOnDisplay = Array.from(document.querySelectorAll('#inspiration-grid .gallery-display'))
    const noResultsMessage = document.querySelector('.inspiration-grid__no-results')
    
    if(imagesOnDisplay.length == 0) {
      noResultsMessage.classList.add('gallery-display')
    }else{
      noResultsMessage.classList.remove('gallery-display')
    }
    
  }


  if(clear){
    clear.addEventListener('click', (e) => {
      e.preventDefault();      
      filters.room = [];
      filters.color = [];
      filters.finish = [];
      document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = false);
      galleryFilter('clear')
    })
  }
  
  roomSelector.forEach(sel => {
    sel.addEventListener('change', function(){
      if(sel.checked) {
        filters.room.push(sel.value)
        galleryFilter(sel)
        
      }else{
        const index = filters.room.indexOf(sel.value);
        filters.room.splice(index, 1)
        galleryFilter(sel)
      
      }
    })    
  })

  colorSelector.forEach(sel => {
    sel.addEventListener('change', function(){
      if(sel.checked) {
        filters.color.push(sel.value)        
        galleryFilter(sel)
        
      }else{
        const index = filters.color.indexOf(sel.value);
        filters.color.splice(index, 1)
        galleryFilter(sel)
       
      }
    })    
  })

  finishSelector.forEach(sel => {
    sel.addEventListener('change', function(){
      if(sel.checked) {
        filters.finish.push(sel.value)
        galleryFilter(sel)
        
      }else{
        const index = filters.finish.indexOf(sel.value);
        filters.finish.splice(index, 1)
        galleryFilter(sel)
        
      }
    })    
  })
  


};
const filterPanel = function () {
  const refineBtn = document.querySelector('.filter-group__btn');
  const filters = document.querySelector('.filter-group__wrapper');
  const closeFilters = document.querySelector('.close-filters');
  const filterButtons = Array.from(document.querySelectorAll('.filter-group .dropdown-toggle'))
  const topContent = document.querySelector('.page-inspiration .top-content')
  const observer = new IntersectionObserver( 
    ([e]) => {
    
     if( e.intersectionRatio < 1) {
      if(refineBtn){
        refineBtn.parentNode.classList.add("is-pinned")
      }
     }else {
      if(refineBtn){
        refineBtn.parentNode.classList.remove("is-pinned")
      }
     }
    },
    { threshold: [1] }
  );
  
  observer.observe(topContent);

  if(filterButtons.length && window.innerWidth < 768) {
    filterButtons.map(elem => {
      elem.addEventListener('click', function(){
        const filterOpen = document.querySelector('.filter-group .dropdown.open');
        if (filterOpen) {
          filterOpen.classList.remove('open');
        }
        if (filterOpen && filterOpen === this.parentNode) {
          this.parentNode.classList.remove('open');
        } else {
          this.parentNode.classList.toggle('open');
        }
        
      })
    })
  }
  const togglePanel = () => {
    if(filters) {
      filters.classList.toggle('active')
      document.querySelector('html').classList.toggle('scroll-locked')
    }
  }
  if(refineBtn) {
    refineBtn.addEventListener('click', togglePanel)
    
  }
  if(closeFilters) {
    closeFilters.addEventListener('click', togglePanel)
  }
}
document.addEventListener('DOMContentLoaded', function () {
  inpiration()
  filterPanel()
});